import { personFormData, personIndexData } from "./PersonForm";
import { productFormData, productIndexData } from "./ProductForm";
import { inventoryFormData, inventoryShortageIndexData, inventorySupplyIndexData } from "./InventoryForm";
import { userFormData } from "./UserForm";
import { userReportFormData } from "./UserReportForm";
import { financialFormData } from "./FinancialForm";
import { accountingIndexData } from "./AccountingForm";
import { chequeIndexData } from "./ChequeForm";
import { factorIndexData } from "./FactorForm";
import { remittanceIndexData } from "./RemittanceForm";
import { transactionIndexData } from "./TransactionForm";
import { profileFormData } from "./ProfileForm";
import { projectFormData } from "./ProjectForm";
import { branchFormData } from "./BranchForm";
import { transferIndexData } from "./TransferForm";
import { capitalIndexData } from "./CapitalForm";
import { journalIndexData } from "./JournalForm";
import { gardeshIndexData, reviewAccountIndexData } from "./ReviewAccountForm";
import { reportTransactionsIndexData } from "./ReportTransactionsForm";
import { debtorsAndCreditorsIndexData } from "./DebtorsAndCreditorsForm";
import { BankTransActionsIndexData } from "./BankTransactionsForm";
import { FundTransactionsIndexData } from "./FundTransactionsForm";
import { CashierTransactionsIndexData } from "./CashierTransactionsForm";
import { SellByProductsIndexData } from "./SellByProductsForm";
import { BuyByProductsIndexData } from "./BuyByProductsForm";
import { SalesByFactorIndexData } from "./SalesByFactorForm";
import { BuysByFactorIndexData } from "./BuysByFactorForm";
import { FactorProfitIndexData } from "./FactorProfitForm";
import { factorSummaryIndexData } from "./FactorSummaryForm";
import { taxReportIndexData } from "./TaxReportForm";
import { userLogIndexData } from "./UserLogForm";
import { personalAccountCardIndexData } from "./PersonalAccountCardForm";
import { productAccountCardIndexData } from "./ProductAccountCardForm";
import { SalaryDocumentIndexData } from "./SalaryForm";
import { installmentIndexData } from "./InstallmentForm";
import { userAccountCardIndexData } from "./UserAccountCardForm";
import { projectAccountCardIndexData } from "./ProjectAccountCardForm";
import { branchAccountCardIndexData } from "./BranchAccountCardForm";
import { smsHistoryIndexData, smsIndexData } from "./SmsForm";
import { taxIndexData, taxNotSentIndexData } from "./taxForm";
import { archiveIndexData } from "./archiveForm";
import { manufactureFormulasIndexData } from "./manufactureFormulasData";
import { manufactureOrderIndexData } from "./manufactureOrderData";
import { costCenterFormData } from "./CostCenterForm";
import { posSettingFormData } from "./PosSetting";
import { productProfitIndexData } from "./ProductProfitForm";
import { stockTaking } from "components/StockTaking/data";
import { SalaryReportByPersonForm } from "./SalaryReportByPersonForm";

export const indexData = (type) => {
  switch (type) {
    case "person":
      return personIndexData;
    case "personalAccountCard":
      return personalAccountCardIndexData;
    case "productAccountCard":
      return productAccountCardIndexData;
    case "projectAccountCard":
      return projectAccountCardIndexData;
    case "branchAccountCard":
      return branchAccountCardIndexData;
    case "userAccountCard":
      return userAccountCardIndexData;
    case "bankTransactions":
      return BankTransActionsIndexData;
    case "salaryDocument":
      return SalaryDocumentIndexData;
    case "fundTransactions":
      return FundTransactionsIndexData;
    case "factorProfit":
      return FactorProfitIndexData;
    case "salesByFactor":
      return SalesByFactorIndexData;
    case "buysByFactor":
      return BuysByFactorIndexData;
    case "cashierTransactions":
      return CashierTransactionsIndexData;
    case "sellByProducts":
      return SellByProductsIndexData;
    case "taxReport":
      return taxReportIndexData;
    case "buyByProducts":
      return BuyByProductsIndexData;
    case "debtorsAndCreditors":
      return debtorsAndCreditorsIndexData;
    case "userLogs":
      return userLogIndexData;
    case "factorSummary":
      return factorSummaryIndexData;
    case "capital":
      return capitalIndexData;
    case "reviewAccount":
      return reviewAccountIndexData;
    case "gardesh":
      return gardeshIndexData;
    case "stockTaking":
      return stockTaking;
    case "journal":
      return journalIndexData;
    case "product":
      return productIndexData;
    case "reportTransactions":
      return reportTransactionsIndexData;
    case "accounting":
      return accountingIndexData;
    case "transaction":
      return transactionIndexData;
    case "transfer":
      return transferIndexData;
    case "installment":
      return installmentIndexData;
    case "factor":
      return factorIndexData;
    case "remittance":
      return remittanceIndexData;
    case "receivedCheques":
      return chequeIndexData.receivedCheques;
    case "paymentCheques":
      return chequeIndexData.paymentCheques;
    case "usersReport":
      return userReportFormData;
    case "inventorySupply":
      return inventorySupplyIndexData;
    case "inventoryShortage":
      return inventoryShortageIndexData;
    case "sms":
      return smsIndexData;
    case "smsHistory":
      return smsHistoryIndexData;
    case "tax":
      return taxIndexData;
    case "taxNotSent":
      return taxNotSentIndexData;
    case "archive":
      return archiveIndexData;
    case 'manufactureFormulas':
      return manufactureFormulasIndexData
    case 'manufactureOrder':
      return manufactureOrderIndexData
    case 'productProfit':
      return productProfitIndexData
    case 'SalaryReportByPerson':
      return SalaryReportByPersonForm
    default:
      return undefined;
  }
};

export const formData = (formType) => {
  switch (formType) {
    case "person":
      return personFormData;
    case "product":
      return productFormData;
    case "financial":
      return financialFormData;
    case "inventory":
      return inventoryFormData;
    case "user":
      return userFormData;
    case "profile":
      return profileFormData;
    case "project":
      return projectFormData;
    case "branch":
      return branchFormData;
    case "costCenter":
      return costCenterFormData;
    case "posSetting":
      return posSettingFormData
    default:
      return undefined;
  }
};
